import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import EmployeeRequiredDialog from "@/components/global_components/dialogs/global-dialogs/EmployeeRequiredDialog";
import dialogInstancePropertyCreator from '@/components/global_components/dialogs/global-dialogs/dialogInstancePropertyCreator';
import store from '@/store';


export default async function checkLinkedEmployee(to, from, next) {
    await store.dispatch('actingUser/refreshActingUserDetails');
    const actingUserDetails = store.getters['actingUser/getActingUserDetails'];
    let employeeId = actingUserDetails?.employeeId;
    if (!employeeId) {
        const employeeRequiredDialog = dialogInstancePropertyCreator(EmployeeRequiredDialog);
        employeeRequiredDialog.open();
        next('/navigation');
    } else {
        checkAuthenticated(to, from, next);
        return next();
    }
}